var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShop = function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    fillRule: "evenodd",
    d: "M2.138 0h14.1l1.666 6.658v.065c0 1.008-.593 1.917-1.303 2.429a1.8 1.8 0 0 1-.62.321 2.6 2.6 0 0 1-.908.168 2.7 2.7 0 0 1-2.024-.916 2.696 2.696 0 0 1-4.049 0 2.696 2.696 0 0 1-4.049 0 2.7 2.7 0 0 1-2.024.916c-.282 0-.614-.054-.908-.168a1 1 0 0 1-.183-.063 1.8 1.8 0 0 1-.437-.258C.69 8.64.096 7.732.096 6.723v-.079zm-.783 6h15.342l-1.23-5h-12.6zM16.88 7h-3.682l.3.617c.302.62.892 1.024 1.575 1.024.177 0 .394-.038.563-.107l.044-.018.039-.008.007-.002.057-.02a.8.8 0 0 0 .197-.118l.013-.011.014-.01c.433-.308.78-.814.872-1.347M12.9 7H9.15l.3.617c.301.62.89 1.024 1.574 1.024s1.273-.404 1.575-1.024zM8.85 7H5.1l.3.617c.303.62.892 1.024 1.576 1.024.683 0 1.273-.404 1.574-1.024zM4.802 7H1.12c.093.533.44 1.04.873 1.347l.014.01.013.011a.8.8 0 0 0 .254.138l.007.002.04.008.043.018c.168.069.386.107.563.107.683 0 1.273-.404 1.575-1.024z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M15 17H3v-6H2v6H0v1h18v-1h-2v-6h-1z"
  })));
};
export default SvgShop;